import React, { useContext, useEffect } from "react";
import Logo from "./Logo";
import userImageMen from "../assets/image/men-user-default.png";
import userImageWomen from "../assets/image/women-user-default.png";
import { NavLink, useHistory } from "react-router-dom";
import { BiBook, BiBookAdd, BiLogOut, BiUser } from "react-icons/bi";
import { LoginContext } from "../context/loginContext";
import { publicUrl } from "../config/api";
import { AiOutlineClose } from "react-icons/ai";

function Sidebar(props) {
  const history = useHistory();
  // eslint-disable-next-line
  const [state, dispatch] = useContext(LoginContext);
  useEffect(() => {
    props.show
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "auto");
  }, [props.show]);
  return (
    <>
      <div
        style={{ width: "300px" }}
        className={`lg:flex ${
          props.show
            ? "lg:flex sm:flex duration-300"
            : "lg:flex md:hidden hidden duration-300"
        }  z-40 inset-0 -translate-x-full duration-500 shadow-xl lg:shadow-none bg-white overflow-auto h-full fixed flex-col items-center pr-2 pl-2 py-1`}
      >
        <div className="mb-6 mt-5 flex items-center">
          <Logo onClick={() => props.handleShowSide(false)} />
          {props.show ? (
            <AiOutlineClose
              className="text-2xl ml-16 bold text-orange-custom mt-4 cursor-pointer"
              onClick={() => props.handleShowSide(!props.show)}
            />
          ) : (
            <></>
          )}
        </div>
        <div className="mb-10">
          {state.user.img === null || !state.user.img ? (
            state.user?.gender === "male" ? (
              <div
                className="border-4 border-white shadow-xl mb-6 rounded-full mx-auto"
                style={imgStyleMen}
              ></div>
            ) : (
              <div
                className="border-4 border-white shadow-xl mb-6 rounded-full mx-auto"
                style={imgStyleWomen}
              ></div>
            )
          ) : (
            <div>
              <img
                className="rounded-full w-24 mx-auto border-4 border-white shadow-xl mb-6 "
                src={`${publicUrl}/${state.user.img}`}
                alt=""
              />
            </div>
          )}
          <p className="text-xl text-center font-extrabold leading-7">
            {state.loading || !state.user ? "Loading...." : state.user.fullName}
          </p>
        </div>
        <div className="block w-full lg:w-3/4 mb-8">
          <hr className="w-full bg-black" style={{ color: "black" }} />
        </div>
        <NavLink
          onClick={() => props.handleShowSide(false)}
          className="items-center inline-flex content-center rounded-full mb-4 hover:bg-orange-custom w-4/5 lg:w-3/5 hover:text-white border-xl py-3 text-gray-600 text-xl text-left pl-6"
          to="/profile"
        >
          <BiUser className="mr-4" />
          Profile
        </NavLink>
        <NavLink
          onClick={() => props.handleShowSide(false)}
          className="items-center inline-flex content-center rounded-full mb-4 hover:bg-orange-custom w-4/5 lg:w-3/5 hover:text-white border-xl py-3 text-gray-600 text-xl text-left pl-6"
          to="/library"
        >
          <BiBook className="mr-4" />
          My Library
        </NavLink>
        <NavLink
          onClick={() => props.handleShowSide(false)}
          className="items-center inline-flex content-center rounded-full mb-4 hover:bg-orange-custom w-4/5 lg:w-3/5 hover:text-white border-xl py-3 text-gray-600 text-xl text-left pl-6"
          to="/add"
        >
          <BiBookAdd className="mr-4" />
          Add Book
        </NavLink>
        <div className="block  lg:w-3/4 w-full mb-8">
          <hr className="w-full bg-black" style={{ color: "black" }} />
        </div>
        <button
          onClick={() => {
            dispatch({
              type: "LOGOUT",
            });
            document.body.style.overflow = "auto";
            history.push("/");
          }}
          className="focus:outline-none items-center inline-flex content-center rounded-full mb-4 hover:bg-orange-custom w-4/5 lg:w-3/5 hover:text-white border-xl py-3 text-gray-600 text-xl text-left pl-6"
        >
          <BiLogOut className="mr-4" />
          Logout
        </button>
      </div>
    </>
  );
}

const imgStyleMen = {
  backgroundImage: "url(" + userImageMen + ")",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  height: "100px",
  width: "100px",
};
const imgStyleWomen = {
  backgroundImage: "url(" + userImageWomen + ")",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  height: "100px",
  width: "100px",
};

export default Sidebar;
